export default {
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  cancel: {
    margin: '0 10px 0 0'
  },
  modalContent: {
    minWidth: '400px !important'
  }
}
